module.exports = __webpack_public_path__ + "img/ltc.272f10f2.svg";